import {
  Component,
  Input,
  OnInit,
  ViewChild,
  OnChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { pluck } from "rxjs";
import { PoEmailHeaderQuoteComponent } from "../po-email-header-quote/po-email-header-quote.component";
import { PoEmailQuoteService } from "../../../../core/services/po-email-quote.service";
import { v4 as uuidv4 } from "uuid";
import { lastValueFrom } from "rxjs";
import { CommonModule, DatePipe } from "@angular/common";
import { GenericResponseDto } from "../../../../core/models/generic-response.dto";
import { EmailTemplates } from "../../../../core/models/orders/emailTemplates";
import { POEmailContact } from "../../../../core/models/orders/poEmailContact";
import { SalesOrderBCInformationDto } from "../../../../core/models/orders/salesOrderBCInformation";
import { VendorInformationForPOEmailDto } from "../../../../core/models/orders/vendorInformationForPOEmailDto";
import { QuotesEmailLogs } from "../../../../core/models/qoutes/quotesEmailLogs";
import { QuotesNotes } from "../../../../core/models/qoutes/quotesNotes";
import { Contact } from "../../../../core/models/shared/contact";
import { FileUploadDto } from "../../../../core/models/shared/fileUploadDto";
import { GetUserDto } from "../../../../core/models/users/users/getUserDto";
import { ValidateLogin } from "../../../../core/models/validate-login.dto";
import { CreateHeaderQuoteService } from "../../../../core/services/create-header-quote.service";
import { CustomerAccountService } from "../../../../core/services/customer-account.service";
import { LoaderService } from "../../../../core/services/loader.service";
import { OrderNotesSidebarService } from "../../../../core/services/order-notes-sidebar.service";
import { OrderSummaryService } from "../../../../core/services/order-summary.service";
import { PoEmailService } from "../../../../core/services/po-email.service";
import { ProfileFormService } from "../../../../core/services/profile-form.service";
import { SaleOrderService } from "../../../../core/services/sale-order.service";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { PoEmailHeaderQuoteService } from "../../../../core/services/po-email-header-quote.service";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { MsalApiService } from "../../../../core/services/msal-api.service";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { PoEmailAttachmentsService } from "../../../../core/services/po-email-attachments.service";
import { EditorComponent } from "../../../../shared/components/editor/editor.component";
import * as MicrosoftGraph from "@microsoft/microsoft-graph-types";
import { PoEmailContactsComponent } from "../../../orders/components/po-email-contacts/po-email-contacts.component";
import { PoEmailAttachmentsComponent } from "../../../orders/components/po-email-attachments/po-email-attachments.component";
import { PoEmailRecipientsComponent } from "../../../orders/components/po-email-recipients/po-email-recipients.component";
import { DisplayPdfFrameQuoteComponent } from "../display-pdf-frame-quote/display-pdf-frame-quote.component";

import { CardModule } from "primeng/card";
import { GetUserProjectDto } from "../../../../core/models/samplePO/details/getUserProjectDto";

@UntilDestroy()
@Component({
  selector: "jni-po-email-quote",
  templateUrl: "./po-email-quote.component.html",
  styleUrls: ["./po-email-quote.component.scss"],
  imports: [
    EditorComponent,
    CommonModule,
    PoEmailContactsComponent,
    PoEmailAttachmentsComponent,
    PoEmailRecipientsComponent,
    PoEmailHeaderQuoteComponent,
    DisplayPdfFrameQuoteComponent,
    CardModule,
  ],
})
export class PoEmailQuoteComponent implements OnInit, OnChanges {
  @Input() quoteId = "";
  @Input() isModal = false;

  poEmailForm!: FormGroup;
  poTemplates: EmailTemplates[] = [];
  purchaseOrderNumberList: string[] = [];
  clientAndProspectContacts: Contact[] = [];

  recipientsList: POEmailContact[] = [];
  bcInformation = {} as SalesOrderBCInformationDto;
  vendorInformation = {} as VendorInformationForPOEmailDto;

  proposalJournalPdf = "";
  proposalJournalPdfUrl = "";
  allBC: GetUserProjectDto[] = [];
  isBC = false;
  filesObject: FileUploadDto[] = [];
  totalFileSizeInKb = 0;
  bcPersonnelNumber = "";
  bacPersonnelNumber = "";
  userPersonnelNumber = "";
  userData!: GetUserDto;
  useremail = "";
  bacEmail = "";
  contacts: Contact[] = [];
  bcName = "";
  customerBillToObject!: ClientSearchList;
  templateId = 0;

  fileAttachmentUrlArray = new Map<string, string>();
  currentTemplete!: EmailTemplates;
  watermark = "";
  primaryVendorContactEmail = "";
  poJournalPdfStatus = false;
  poEmailDisplayModal = false;

  poEmailScreenStatus = false;
  emailToArray: string[] = [];
  csvEmailTo = "";
  fromEmail = "";
  currentDateForNote = "";
  poNumberParams = "";
  notesId: number | null = 0;
  displaySendButton = true;
  @ViewChild("emailComponent", { static: false })
  emailComponent!: EditorComponent;
  @Output() closeEvent = new EventEmitter();

  @ViewChild("poheader", { static: false })
  poheader!: PoEmailHeaderQuoteComponent;
  fileName = "";
  formErrors: Record<string, string> = {
    subject: "",
  };

  validationMessages: Record<string, Record<string, string>> = {
    subject: {
      maxlength: "Subject must be less than 255 characters.",
    },
  };

  templateBody = "";

  constructor(
    private _fb: FormBuilder,
    private _activatedRoute: ActivatedRoute,
    private _loaderService: LoaderService,
    private _toastr: JniToastrService,
    private _poEmailQuoteService: PoEmailQuoteService,
    private _orderNotesSidebarService: OrderNotesSidebarService,
    private _saleOrderService: SaleOrderService,
    private _msalApisService: MsalApiService,
    private _orderSummaryService: OrderSummaryService,
    private _samplepoListingService: SamplepoListingService,
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService,
    private _customerAccountService: CustomerAccountService,
    private _poEmailHeaderQuoteService: PoEmailHeaderQuoteService,
    private _poEmailService: PoEmailService,
    public datepipe: DatePipe,
    private _poEmailAttachmentsService: PoEmailAttachmentsService,
    private _createHeaderQuoteService: CreateHeaderQuoteService
  ) {
    this._activatedRoute.params.subscribe(params => {
      this.quoteId = params["id"];
    });
    this.initializeForm();
    // this.setSender();
  }

  ngOnInit(): void {
    this.getQuotesData(false);
    this.getPOTemplates();
    this.patchValueInPoNumber();
    this.getUserProfile();
    this.getEmailPoTemplate();
    this.setPdfFileName();
  }

  ngOnChanges() {
    this.setPdfFileName();
  }

  logValidationErrors(group: FormGroup = this.poEmailForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (
          abstractControl &&
          !abstractControl.valid &&
          (abstractControl.touched || abstractControl.dirty)
        ) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  private initializeForm() {
    //const userJson = localStorage.getItem('user') || '';
    //const userObject = JSON.parse(userJson);
    //const useremail = userObject?.account?.username || '';
    this.poEmailForm = this._fb.group({
      header: this._fb.group({
        templateId: [null],
        proposalNumber: [""],
        poNumberRevision: [""],
        rush: [false],
        revised: [false],
        sender: [{ value: "", disabled: true }],
        subject: ["", [Validators.maxLength(255)]],
        additionalSubject: [""],
        reply: [{ value: "", disabled: true }],
      }),
    });
  }

  getEmailPoTemplate() {
    this._poEmailHeaderQuoteService.selectedproposalNumber$.subscribe(value => {
      if (value) {
        this.templatedSelected(this.templateId);
      }
    });
  }

  patchValueInPoNumber() {
    this.poEmailForm?.patchValue({
      header: {
        proposalNumber: this.quoteId,
      },
    });
    this.poEmailForm?.get(["header", "proposalNumber"])?.disable();
    this.poEmailForm.patchValue({
      header: {
        subject: `Nadel Proposal - ${
          this.poEmailForm.get(["header", "proposalNumber"])?.value || ""
        }`,
      },
    });
    this.getCustomerInformationForPOEmail(false);
  }

  waterMarkPdf(waterMarkCheck: boolean) {
    if (waterMarkCheck) {
      this.getCustomerInformationForPOEmail(waterMarkCheck);
    } else {
      this.getCustomerInformationForPOEmail(waterMarkCheck);
    }
  }

  getCustomerInformationForPOEmail(waterMarkCheck: boolean) {
    if (this.quoteId) {
      if (waterMarkCheck) {
        this._poEmailQuoteService
          .ProposalSummaryDocument(this.quoteId, "Revised")
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                this.proposalJournalPdf = res.data;
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      } else {
        this._poEmailQuoteService
          .ProposalSummaryDocument(this.quoteId)
          .subscribe({
            next: res => {
              this._loaderService.setLoaderState(false);
              if (res.status.toLowerCase() == "success") {
                this.proposalJournalPdf = res.data;
              }
            },
            error: () => {
              this._loaderService.setLoaderState(false);
            },
          });
      }
    }
  }

  getPOTemplates() {
    this._loaderService.setLoaderState(true);
    this._poEmailService
      .getEmailTemplatesByType("Quotes-Email")
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.poTemplates = res?.data || [];
          this.currentTemplete = this.poTemplates[0];
          this.templateId = this.poTemplates[0]?.id;
          this.poEmailForm.patchValue({
            header: {
              templateId: this.templateId,
            },
          });
          this._poEmailHeaderQuoteService.onRushSelection(true);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getQuotesData(getloaderStatus: boolean) {
    if (this.quoteId) {
      this._loaderService.setLoaderState(getloaderStatus);
      this._createHeaderQuoteService
        .getQuotesData(this.quoteId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.data) {
              if (res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365) {
                this.getCustomerDetail(
                  res.data.salesOrderHeader?.salesOrderHeader?.customerIdD365
                );
              }
              if (
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.brandingConsultantD365
              ) {
                this.bcPersonnelNumber =
                  res.data.salesOrderHeader?.salesOrderHeader?.brandingConsultantD365;

                this.getBrandingConsultantOnSaleOrder(this.userData);
              }
              if (
                res.data.salesOrderHeader?.salesOrderHeader
                  ?.accountsCoordinatorD365
              ) {
                this.bacPersonnelNumber =
                  res.data.salesOrderHeader?.salesOrderHeader?.accountsCoordinatorD365;
              }
            } else {
              this._toastr.error("Error", res.message || "Data not found");
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Data not found");
          },
        });
    }
  }

  getCustomerDetail(customerAccountNumber: string) {
    this._customerAccountService
      .getCustomerByNameAndAccountNumberFilter(customerAccountNumber)
      .subscribe({
        next: res => {
          if (res.data) {
            this.customerBillToObject = res?.data[0];
            this._poEmailHeaderQuoteService?.onRushSelection(true);
            this.getAllContactsByAccountNumber(
              this.customerBillToObject?.clientAccount,
              this.customerBillToObject?.partyNumber
            );
          }
        },
      });
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: async res => {
        if (res?.data) {
          this.userData = res?.data;
          this.userPersonnelNumber = res?.data?.personnelNumber;
          this.fromEmail = res.data.sendEmailAs;
          this.getBrandingConsultantOnSaleOrder(res?.data);
        }
      },
    });
  }

  getBrandingConsultantOnSaleOrder(data: GetUserDto) {
    if (data && this.bcPersonnelNumber) {
      this.useremail = data.sendEmailAs;
      this.bacEmail = data?.primaryBACEmail;
      this.bcName = data.name;
      this.poEmailForm.patchValue({
        header: {
          sender: this.useremail || "",
          reply: this.useremail || "",
        },
      });
    }
    this._poEmailHeaderQuoteService.onRushSelection(true);
  }

  patchValueInRecipients(email: string) {
    const object = {
      id: Date.now(),
      locatorD365: email,
      descriptionD365: "",
      purposeD365: "",
      isPrimaryD365: "",
      addType: "CC",
    } as POEmailContact;
    this.recipientsList.push(object);
  }

  templatedSelected(id: number) {
    if (id > 0) {
      const index = this.poTemplates?.findIndex(x => x.id == id);
      if (index > -1) {
        const template = this.poTemplates[index];
        this.templateBody = template.body;
        //this.emailComponent?.emailEditor?.editor?.setContent(template.body);
        this.patchValueInEditor();
      }
    }
  }

  getAllBC() {
    this._samplepoListingService.getAllBrandingConsultant().subscribe({
      next: res => {
        if (res.status.toLowerCase() == "success") {
          this.allBC = res.data;
          const index = this.allBC.findIndex(
            x => x.personnelNumber == this.bcInformation.personnelNumber
          );
          if (index > -1) {
            this.isBC = true;
          }
        }
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  setSender() {
    //const userJson = localStorage.getItem('user') ?? '';
    //const userObject = JSON.parse(userJson);
    //const useremail = userObject?.account?.username || '';
    this.poEmailForm.patchValue({
      header: {
        sender: this.useremail,
      },
    });
  }

  getAllLinePoNumber() {
    if (this.quoteId) {
      this._loaderService.setLoaderState(true);
      this._orderNotesSidebarService
        .getAllLinePoNumber(this.quoteId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            this.purchaseOrderNumberList = res.data;
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  getSalesOrderBCInformation() {
    this._poEmailQuoteService
      .getSalesOrderBCInformation(this.quoteId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.bcInformation = res.data;

          this.patchValueInEditor();
          if (res.status.toLowerCase() == "success") {
            this.getAllBC();
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getAllContactsByAccountNumber(accountNumber: string, partyNumber = "") {
    this._saleOrderService
      .getAllContactsByAccountNumber(accountNumber, partyNumber)
      .pipe(pluck("data"))
      .subscribe({
        next: data => {
          this.contacts = data.filter(
            x =>
              x.typeD365?.toLowerCase() === "email" &&
              x.isPrimaryD365?.toLowerCase() === "no"
          );
          this.clientAndProspectContacts = JSON.parse(
            JSON.stringify(this.contacts)
          );
          const primaryContact = this.contacts.filter(
            x =>
              x.isPrimaryD365?.toLowerCase() === "yes" &&
              x.purposeD365?.toLowerCase()?.includes("business")
          );
          if (primaryContact.length > 0) {
            const object = {
              locatorD365: primaryContact[0].locatorD365,
              descriptionD365: primaryContact[0].descriptionD365,
              purposeD365: primaryContact[0].purposeD365,
              isPrimaryD365: primaryContact[0].isPrimaryD365,
              addType: "TO",
            } as POEmailContact;
            this.primaryVendorContactEmail =
              primaryContact[0].locatorD365 ?? "";
            this.recipientsList.push(object);
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  addCC(addCCList: Contact[]) {
    addCCList.forEach((x: Contact) => {
      const index = this.clientAndProspectContacts.findIndex(a => a.id == x.id);
      if (index > -1) {
        this.clientAndProspectContacts.splice(index, 1);
      }
      this.recipientsList.push({ ...x, addType: "CC", descriptionD365: "" });
    });
  }

  addTO(addTOList: Contact[]) {
    addTOList.forEach(x => {
      const index = this.clientAndProspectContacts.findIndex(a => a.id == x.id);
      if (index > -1) {
        this.clientAndProspectContacts.splice(index, 1);
      }
      this.recipientsList.push({ ...x, addType: "TO", descriptionD365: "" });
    });
  }

  recipientsDeleted(deletedList: POEmailContact[]) {
    for (const contact of deletedList) {
      const index = this.recipientsList.findIndex(x => x.id == contact.id);
      if (index > -1) {
        this.recipientsList.splice(index, 1);
      }
      if (this.contacts.findIndex(x => x.id == contact.id) > -1) {
        this.clientAndProspectContacts.push(contact);
      }
    }
  }

  recipientsAdd() {
    this.recipientsList.push({
      id: Date.now(),
      addType: "CC",
      locatorD365: "",
      firstNameD365: "",
      lastNameD365: "",
      typeD365: "",
      createdDate: new Date().toISOString(),
      createdBy: this.useremail,
      lastModifiedDate: new Date().toISOString(),
      lastModifiedBy: this.useremail,
      isActive: true,
      descriptionD365: undefined,
      otherSpecification: "",
    });
  }

  patchValueInEditor() {
    let content = this.templateBody; //this.emailComponent?.emailEditor?.editor?.getContent();
    if (content) {
      content = content.replace(
        "#{ClientName}",
        this.customerBillToObject?.name ?? ""
      );
      content = content.replace("{ProposalNumber}", this.quoteId);
      content = content.replace("#{currentUser}", this.useremail);
      content = content.replace("#{BCName}", this.bcName || "");
      this.templateBody = content;
      //this.emailComponent?.emailEditor?.editor?.setContent(content);
    }
  }

  getAttachmentFileArray(event: FileUploadDto[]) {
    this.filesObject = event;
  }

  getTotalFileSize(event: number) {
    this.totalFileSizeInKb = event;
  }

  submitButtonlogValidationErrors(group: FormGroup = this.poEmailForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.submitButtonlogValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = "";
        if (abstractControl && !abstractControl.valid) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey && messages) {
              this.formErrors[key] += messages[errorKey] + " ";
            }
          }
        }
      }
    });
  }

  async sendEmail(content: string) {
    this.submitButtonlogValidationErrors();
    this.csvEmailTo = "";
    if (!this.poEmailForm.valid) {
      return;
    }

    if (this.filesObject.length >= 250) {
      this._toastr.error(`File attachments must be less than 250`, "Error");
      return;
    }

    if (this.totalFileSizeInKb >= 33000) {
      this._toastr.error(
        `Total file attachments size must be less than 33MB`,
        "Error"
      );
      return;
    }

    const attachmentObject = {
      base64: this.proposalJournalPdf,
      fileExtension: ".pdf",
      fileId: 1,
      fileMimeType: "application/pdf",
      fileName: `${this.quoteId}.pdf`,
    } as FileUploadDto;
    const res = await lastValueFrom(
      this._poEmailAttachmentsService.getPoEmailAttachmentUrl(attachmentObject)
    );
    this.proposalJournalPdfUrl = res.data;

    const toRecipients: MicrosoftGraph.Recipient[] = [];
    const ccRecipients: MicrosoftGraph.Recipient[] = [];
    const to = this.recipientsList.filter(x => x.addType == "TO");
    const cc = this.recipientsList.filter(x => x.addType == "CC");

    for (const x of to) {
      if (!this.isValidEmail(x.locatorD365 ?? "")) {
        this._toastr.error(`Invalid Email ${x.locatorD365}`, "Error");
        return;
      }
    }
    for (const x of cc) {
      if (!this.isValidEmail(x.locatorD365 ?? "")) {
        this._toastr.error(`Invalid Email ${x.locatorD365}`, "Error");
        return;
      }
    }

    to.forEach(x => {
      toRecipients.push({
        emailAddress: {
          address: x.locatorD365,
          name: x.descriptionD365 ?? undefined,
        },
      });
    });
    cc.forEach(x => {
      ccRecipients.push({
        emailAddress: {
          address: x.locatorD365,
          name: x.descriptionD365 ?? undefined,
        },
      });
    });

    const attachement = [];
    attachement.push({
      contentBytes: this.proposalJournalPdf,
      name: `${this.quoteId}.pdf`,
      contentType: "application/pdf",
      "@odata.type": "#microsoft.graph.fileAttachment",
    });

    if (this.filesObject.length > 0) {
      for (const key in this.filesObject) {
        attachement.push({
          contentBytes: this.filesObject[key].base64,
          name: `${this.filesObject[key].fileName}`,
          contentType: this.filesObject[key].fileMimeType,
          "@odata.type": "#microsoft.graph.fileAttachment",
        });
      }
    }

    let mailMessage: MicrosoftGraph.Message = {};
    const replyTo: MicrosoftGraph.Recipient[] = [
      {
        emailAddress: {
          address: this.useremail,
          name: this.useremail,
        },
      },
    ];

    const fromTo: MicrosoftGraph.Recipient = {
      emailAddress: {
        address: this.useremail,
        name: this.useremail,
      },
    };

    mailMessage = {
      subject: this.poEmailForm.get(["header", "subject"])?.value || "",
      body: {
        contentType: "html",
        content: content,
      },
      toRecipients: toRecipients,
      ccRecipients: ccRecipients,
      attachments: attachement,
      replyTo: replyTo,
      from: fromTo,
    };

    const mail = {
      message: mailMessage,
    };

    this._loaderService.setLoaderState(true);
    this.displaySendButton = false;
    this._msalApisService.sendMail(mail).subscribe({
      next: () => {
        this._loaderService.setLoaderState(false);
        this._toastr.success("Email Sent Successfully", "Success");
        this.updateQuotesStatus();
        const emails = [...toRecipients, ...ccRecipients];
        this.quoteNotes(emails, content, ccRecipients, toRecipients);
      },
      error: err => {
        this._loaderService.setLoaderState(false);
        this._toastr.error(
          err?.error?.error?.message || "Unable To Send Mail",
          "Error"
        );
        this.displaySendButton = true;
      },
    });
  }

  updateQuotesStatus() {
    const status = "EMailed";
    this._poEmailQuoteService
      .updateQuotesStatus(this.quoteId, status)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getFileUrl(object: FileUploadDto) {
    this._loaderService.setLoaderState(true);
    this._poEmailAttachmentsService
      .getPoEmailAttachmentUrl(object)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: () => {
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  attachmentFileUrlArray(fileUrl: Map<string, string>) {
    this.fileAttachmentUrlArray = fileUrl;
  }

  sendEmailsLog(
    content: string,
    cc: MicrosoftGraph.Recipient[],
    to: MicrosoftGraph.Recipient[]
  ) {
    const attachementsArray = Array.from(this.fileAttachmentUrlArray).map(
      ([key, value]) => ({
        key,
        value,
      })
    );

    if (this.proposalJournalPdfUrl) {
      attachementsArray.push({
        key: `${this.quoteId}.pdf`,
        value: this.proposalJournalPdfUrl,
      });
    }

    const rush = this.poEmailForm.get(["header", "rush"])?.value;
    const revised = this.poEmailForm.get(["header", "revised"])?.value;
    if (rush && revised) {
      this.watermark = "All";
    } else if (rush) {
      this.watermark = "Rush";
    } else if (revised) {
      this.watermark = "Revised";
    } else {
      this.watermark = "";
    }

    const poEmailLogs = {
      templateId: this.currentTemplete?.id,
      additionalSubject: this.poEmailForm.get(["header", "additionalSubject"])
        ?.value,
      templateName: this.currentTemplete?.name,
      sender: this.poEmailForm.get(["header", "sender"])?.value,
      reply: this.poEmailForm.get(["header", "reply"])?.value,
      subject: this.poEmailForm.get(["header", "subject"])?.value,
      attachement: JSON.stringify(attachementsArray),
      body: content,
      cc: JSON.stringify(cc),
      to: JSON.stringify(to),
      from: this.poEmailForm.get(["header", "sender"])?.value,
      id: 0,
      watermark: this.watermark,
      proposalNumber: this.quoteId,
      notesId: this.notesId,
    } as QuotesEmailLogs;

    this._poEmailQuoteService.createQuotesEmailLogs(poEmailLogs).subscribe();
  }

  quoteNotes(
    to: MicrosoftGraph.Recipient[],
    content: string,
    ccRecipients: MicrosoftGraph.Recipient[],
    toRecipients: MicrosoftGraph.Recipient[]
  ) {
    this.currentDateForNote = "";

    this.emailToArray = [];
    if (to.length > 0) {
      for (const x of to) {
        if (x.emailAddress?.address) {
          this.emailToArray.push(x?.emailAddress?.address);
        }
      }
      if (this.emailToArray.length > 0) {
        this.csvEmailTo = this.emailToArray?.toString();
      }
    }

    const rush = this.poEmailForm.get(["header", "rush"])?.value;
    const revised = this.poEmailForm.get(["header", "revised"])?.value;
    if (rush && revised) {
      this.watermark = "Rush Revised";
    } else if (rush) {
      this.watermark = "Rush";
    } else if (revised) {
      this.watermark = "Revised";
    } else {
      this.watermark = "";
    }

    const currentDate = new Date();
    this.currentDateForNote =
      this.datepipe.transform(currentDate, "MM/dd/yyyy") ?? "";

    const saleOrderFormObject = {
      type: "Proposal",
      purchaseOrderId: "",
      description: "Emailed Proposal",
      note: this.csvEmailTo
        ? `${this.currentDateForNote} To ${this.csvEmailTo}`
        : `${this.currentDateForNote}`,
      id: 0,
      purchaseOrderStatus: true,
    } as unknown as QuotesNotes;

    if (this.quoteId) {
      saleOrderFormObject.salesOrderId = this.quoteId;
      saleOrderFormObject.portalKey = uuidv4();
    }

    this._poEmailQuoteService
      .AddQuoteNotes(saleOrderFormObject)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res) {
            this.notesId = res.data ?? null;
            this.sendEmailsLog(content, ccRecipients, toRecipients);
          }
        },
        error: () => {
          this.notesId = null;
          this.sendEmailsLog(content, ccRecipients, toRecipients);
          this._loaderService.setLoaderState(false);
        },
      });
  }

  isValidEmail(email: string): boolean {
    const regex = `^[a-zA-Z0-9._%+-]+(?:'[a-zA-Z0-9._%+-]+)?@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$`;
    if (RegExp(regex).exec(email)) {
      return true;
    }
    return false;
  }

  fetchWatermarkedPdf(watermark: { rush: boolean; revised: boolean }) {
    this._loaderService.setLoaderState(true);
    if (watermark.revised && watermark.rush) {
      this._loaderService.setLoaderState(false);
    } else if (watermark.rush) {
      this._orderSummaryService
        .printPOForSalesOrder(this.quoteId, "Rush")
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.proposalJournalPdf = res.data;
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    } else if (watermark.revised) {
      this._orderSummaryService
        .printPOForSalesOrder(this.quoteId, "Revised")
        .subscribe({
          next: res => {
            this._loaderService.setLoaderState(false);
            if (res.status.toLowerCase() == "success") {
              this.proposalJournalPdf = res.data;
            }
          },
          error: () => {
            this._loaderService.setLoaderState(false);
          },
        });
    }
  }

  template() {
    this._poEmailHeaderQuoteService?.onRushSelection(true);
  }

  emailSelection() {
    this.poEmailScreenStatus = true;
  }

  setPdfFileName() {
    this.fileName = `${this.quoteId}.pdf`;
  }

  closeProposalEmailModal() {
    this.closeEvent.emit();
  }
}
